import type { AppStoreState } from "../state/app-store";
import { useAppStoreApi } from "../state/app-store-context";
import { useStore } from "zustand";

export function useAppStore<T>(selector: (state: AppStoreState) => T): T {
  const store = useAppStoreApi();
  return useStore(store, selector);
}
